import React from "react";

const readers = [
  {
    name: "Non Visual Desktop Access (NVDA)",
    website: "http://www.nvda-project.org/",
    type: "Free",
  },
  {
    name: "System Access To Go",
    website: "http://www.satogo.com/",
    type: "Free",
  },
  {
    name: "Hal",
    website: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
    type: "Commercial",
  },
  {
    name: "JAWS",
    website:
      "http://www.freedomscientific.com/Products/software/JAWS/",
    type: "Commercial",
  },
  {
    name: "Supernova",
    website:
      "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
    type: "Commercial",
  },
  {
    name: "Window-Eyes",
    website: "http://www.gwmicro.com/Window-Eyes/",
    type: "Commercial",
  },
];

export default function ScreenReader() {
  return (
    <div className="container py-5">

      {/* Heading */}
      <h2 className="fw-normal display-6 d-flex align-items-center gap-2 mb-1">
        <i className="bi bi-volume-up-fill text-warning"></i>
        Screen Reader
      </h2>

      <div
        className="mb-4"
        style={{
          width: "90px",
          height: "4px",
          background: "#f57c00",
        }}
      ></div>

      {/* Description */}
      <p className="fs-5 lh-lg text-secondary">
        The website will enable people with visual impairments access the
        website using assistive technologies, including screen readers. The
        information of the website is accessible with different screen
        readers, such as JAWS, NVDA, SAFA, Supernova and Window-Eyes.
        Following table lists the information about different screen readers:
      </p>

      {/* Card */}
      <div className="card border-0 shadow-sm rounded-4">

        <div
          className="card-header fw-semibold fs-4 py-3"
          style={{ backgroundColor: "#dff4e5" }}
        >
          Information related to the various screen readers
        </div>

        <div className="table-responsive">

          <table className="table table-bordered table-hover align-middle mb-0">

            <thead style={{ backgroundColor: "#e9f8ed" }}>
              <tr>
                <th className="py-3">Screen Reader</th>
                <th className="py-3">Website</th>
                <th className="py-3">Free/ Commercial</th>
              </tr>
            </thead>

            <tbody>
              {readers.map((reader, index) => (
                <tr key={index}>
                  <td>{reader.name}</td>

                  <td>
                    <a
                      href={reader.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-success text-decoration-none"
                    >
                      {reader.website}
                    </a>
                  </td>

                  <td>{reader.type}</td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}